import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'DEmpty',
  props: {
  description: {
    type: String,
    default: "暂无数据",
  },
},
  setup(__props) {



return { __sfc: true, }
}

})